import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { getAttrValue, getLocalizedAttrValue, getLocalizedValue, getNestedProperty, isPresent } from "@grandvisionhq/utils";
function getProductTypeName(product) {
  const result = product && product.productType && product.productType.obj && CommerceToolsApi.isProductTypeName(product.productType.obj.name) ? product.productType.obj.name : false;
  return !!result ? result : void 0;
}
function getProductModelName(variant, locale, productType) {
  if (CommerceToolsApi.isLenses(productType)) {
    return getLocalizedAttrValue(variant, "materialType", locale) || "";
  }
  return variant.name || "";
}
function getActiveVariant(product, sku) {
  if (!sku) {
    return product.masterVariant;
  }
  if (product.masterVariant.sku === sku) {
    return product.masterVariant;
  }
  return product.variants.find((variant) => variant.sku === sku) || product.masterVariant;
}
const getLensPropertyValue = (variant, attrName) => {
  const value = getAttrValue(variant, attrName);
  if (!isPresent(value) || !(typeof value === "number" || typeof value === "string")) {
    return void 0;
  }
  return String(value);
};
function getFullImageUrls(variant) {
  const images = getNestedProperty(variant, "media.images", []);
  return images;
}
function getCCCVisualProduct(product, productType, locale, variant) {
  const activeVariant = !variant || typeof variant === "string" ? getActiveVariant(product, variant) : variant;
  const sharedProductInfo = {
    sku: activeVariant.sku || "",
    productType,
    images: getFullImageUrls(activeVariant),
    brand: String(getAttrValue(activeVariant, "brand")),
    modelName: getProductModelName(activeVariant, locale, productType)
  };
  if (CommerceToolsApi.isLenses(productType)) {
    const info = {
      ...sharedProductInfo,
      productType: "Contact-lenses",
      brand: getLocalizedValue(product.name, locale),
      replacementFrequency: getLocalizedAttrValue(activeVariant, "replacementFrequency", locale),
      packageQuantity: Number(getAttrValue(activeVariant, "packageQuantity")),
      lensProperties: {
        power: getLensPropertyValue(activeVariant, "power"),
        baseCurve: getLensPropertyValue(activeVariant, "baseCurve"),
        diameter: getLensPropertyValue(activeVariant, "diameter"),
        axis: getLensPropertyValue(activeVariant, "axis"),
        cylinder: getLensPropertyValue(activeVariant, "cylinder"),
        addition: getLensPropertyValue(activeVariant, "addition"),
        color: getLensPropertyValue(activeVariant, "color")
      }
    };
    return info;
  }
  return sharedProductInfo;
}
export {
  getActiveVariant,
  getCCCVisualProduct,
  getFullImageUrls,
  getLensPropertyValue,
  getProductModelName,
  getProductTypeName
};
//# sourceMappingURL=get-ccc-visual-product.js.map
